import { flexRender } from '@tanstack/react-table';
import React from 'react';

import { Box, Typography } from 'shared';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { ResourceBankTableHeaderCell } from 'features/resourceBank/components/Table/HeaderCell';
import { useResourceTableData } from 'features/resourceBank/hooks/useResourcesTableData';
import { Resource } from 'features/resourceBank/types';

import styles from 'features/sessions/components/Table.module.css';

type ResourceBankTableProps = {
  resources: Resource[];
  title: string;
};

export const ResourceBankTable = ({
  resources,
  title,
}: ResourceBankTableProps) => {
  const table = useResourceTableData(resources);

  return (
    <Box pt={3}>
      <Typography>{title}</Typography>
      <Box
        style={{
          borderRadius: '0.5rem',
          overflow: 'hidden',
          border: 'var(--border-secondary)',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
          }}
        >
          <thead
            style={{
              backgroundColor: 'var(--bgCompSecondaryBig)',
              borderBottom: 'var(--border-secondary)',
            }}
          >
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th key={header.id} style={{ width: header.getSize() }}>
                    <ResourceBankTableHeaderCell data={header} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <React.Fragment key={row.original.id}>
                <tr
                  data-testid="sessions-table-row"
                  style={{
                    borderBottom: 'var(--border-secondary)',
                  }}
                  className={styles.row}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      <Spacer size="lg">
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </Spacer>
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
};
